import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ProjectForm from "../../components/Project/ProjectForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ProjectEdit = ({classes, project, uploadConfig}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('project.status_form.heading_add')}
        />

        <Card>
            <CardContent>
                <ProjectForm
                    values={project || {}}
                    uploadConfig={uploadConfig}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default ProjectEdit;
